import { globalFetch } from './globalActions';
import { checkLang } from '../helpers';
import { PODCASTS_HAS_ERRORED, PODCASTS_IS_LOADING, PODCASTS_FETCH_DATA_SUCCESS } from './types';

///////////
// Podcasts Feeds //
///////////

function fetchPodcasts(podcastsArray, id) {
	const lang = checkLang(false, true);
	let items= [];
	if(Object.keys(podcastsArray).length > 0) {
		Object.keys(podcastsArray).forEach(function(key) {
			if(parseInt(key, 10) === parseInt(id, 10)) {
				if(Object.keys(podcastsArray[key]).length > 0) {
					Object.keys(podcastsArray[key]).forEach(function(keyItem) {
						items.push(podcastsArray[key][keyItem][lang]);
					});
				}
			}
		});
	}
	return items;
}

export function fetchProgrammePodcasts(programme_id, series_id) {
	return globalFetch({
			urlPath: `podcasts`,
			urlSrc: 1,
			reducerIsLoading: PODCASTS_IS_LOADING,
			reducerError: PODCASTS_HAS_ERRORED,
			dispatchSuccess: (itemObj, dispatch) => {
				const itemsProg = fetchPodcasts(itemObj.programme_id[0], programme_id);
				const itemsSeries = fetchPodcasts(itemObj.series_id[0], series_id);
				const results = itemsProg.concat(itemsSeries).sort((a,b) => (a.title > b.title) ? 1 : ((b.title > a.title) ? -1 : 0));
				dispatch({ type: PODCASTS_FETCH_DATA_SUCCESS, payload: results });
			}
	});
}
